import styled from 'styled-components';

export default styled.div`
  margin: 0 auto;
  width: 100%;
  padding: 0 2rem; 
  max-width: 1366px;
`;